import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import ProtectedRoute from "component/ProtectedRoute";
import { AuthProvider } from "component/AuthContext";

import Login from "pages/Login.js";
import Dashboard from "pages/Dashboard";
import Analytics from "pages/dashboard/Analytics";
import Calendar from "pages/dashboard/Calendar";

import Employee from "pages/hrd/Employee";
import Absensi from "pages/hrd/Absensi";

import User from "pages/master/User";
import Menu from "pages/master/Menu";
import Access from "pages/master/Access";
import Bank from "pages/master/Bank";
import Category from "pages/master/Category";
import Item from "pages/master/Item";
import Feature from "pages/master/Feature";
import Room from "pages/master/Room";

import Pending from "pages/booking/all booking/Pending";
import Accepted from "pages/booking/all booking/Accepted";
import Canceled from "pages/booking/all booking/Canceled";
import NewBooking from "pages/booking/NewBooking";
import AddBooking from "pages/booking/AddBooking";

import TJurnalUmum from "pages/akunting/transaksi/JurnalUmum";
import TJurnalPendapatan from "pages/akunting/transaksi/JurnalPendapatan";
import TJurnalBiaya from "pages/akunting/transaksi/JurnalBiaya";

import RChartOfAccount from "pages/akunting/report/RChartOfAccount";
import RNeraca from "pages/akunting/report/Neraca";
import RDetailNeraca from "pages/akunting/report/DetailNeraca";
import RLabaRugi from "pages/akunting/report/LabaRugi";
import RDetailLabaRugi from "pages/akunting/report/DetailLabaRugi";
import RCashFlow from "pages/akunting/report/CashFlow";
import RGeneralLedger from "pages/akunting/report/GeneralLedger";
import RSummaryJurnal from "pages/akunting/report/SummaryJurnal";
import RLaporanKasRek from "pages/akunting/report/LaporanKasRek";

import MChartOfAccount from "pages/akunting/master/ChartOfAccount";
import MClosingLabaRugi from "pages/akunting/master/ClosingLabaRugi";
import MGroupAccount from "pages/akunting/master/GroupAccount";
import MMasterChartAccount from "pages/akunting/master/MasterChartAccount";
import MPindahBulan from "pages/akunting/master/PindahBulan";

function App() {

  return (
    <Router>
      <AuthProvider>
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />

            {/* dashboard */}
            <Route path="/analytics" element={<ProtectedRoute><Analytics /></ProtectedRoute>} />
            <Route path="/calendar" element={<ProtectedRoute><Calendar/></ProtectedRoute>} />
            
            {/* master */}
            <Route path="/user" element={<ProtectedRoute><User /></ProtectedRoute>} />
            <Route path="/menu" element={<ProtectedRoute><Menu /></ProtectedRoute>} />
            <Route path="/access" element={<ProtectedRoute><Access /></ProtectedRoute>} />
            <Route path="/bank" element={<ProtectedRoute><Bank /></ProtectedRoute>} />
            <Route path="/category" element={<ProtectedRoute><Category /></ProtectedRoute>} />
            <Route path="/item" element={<ProtectedRoute><Item /></ProtectedRoute>} />
            <Route path="/feature" element={<ProtectedRoute><Feature /></ProtectedRoute>} />
            <Route path="/room" element={<ProtectedRoute><Room /></ProtectedRoute>} />

            {/* hrd */}
            <Route path="/employee" element={<ProtectedRoute><Employee /></ProtectedRoute>} />
            <Route path="/absensi" element={<ProtectedRoute><Absensi /></ProtectedRoute>} />

            {/* booking */}
            <Route path="/new-booking" element={<ProtectedRoute><NewBooking /></ProtectedRoute>} />
            <Route path="/new-booking/:id" element={<ProtectedRoute><AddBooking /></ProtectedRoute>} />
            <Route path="/booking-pending" element={<ProtectedRoute><Pending /></ProtectedRoute>} />
            <Route path="/booking-accepted" element={<ProtectedRoute><Accepted /></ProtectedRoute>} />
            <Route path="/booking-canceled" element={<ProtectedRoute><Canceled /></ProtectedRoute>} />
            
            {/* akunting */}
            <Route path="/jurnal-umum" element={<ProtectedRoute><TJurnalUmum /></ProtectedRoute>} />
            <Route path="/jurnal-pendapatan" element={<ProtectedRoute><TJurnalPendapatan /></ProtectedRoute>} />
            <Route path="/jurnal-biaya" element={<ProtectedRoute><TJurnalBiaya /></ProtectedRoute>} />

            <Route path="/report-chart-of-account" element={<ProtectedRoute><RChartOfAccount /></ProtectedRoute>} />
            <Route path="/kas-rekening" element={<ProtectedRoute><RLaporanKasRek /></ProtectedRoute>} />
            <Route path="/neraca" element={<ProtectedRoute><RNeraca /></ProtectedRoute>} />
            <Route path="/detail-neraca" element={<ProtectedRoute><RDetailNeraca /></ProtectedRoute>} />
            <Route path="/laba-rugi" element={<ProtectedRoute><RLabaRugi /></ProtectedRoute>} />
            <Route path="/detail-laba-rugi" element={<ProtectedRoute><RDetailLabaRugi /></ProtectedRoute>} />
            <Route path="/cash-flow" element={<ProtectedRoute><RCashFlow /></ProtectedRoute>} />
            <Route path="/general-ledger" element={<ProtectedRoute><RGeneralLedger /></ProtectedRoute>} />
            <Route path="/summary-jurnal" element={<ProtectedRoute><RSummaryJurnal /></ProtectedRoute>} />

            <Route path="/closing-laba-rugi" element={<ProtectedRoute><MClosingLabaRugi /></ProtectedRoute>} />
            <Route path="/pindah-bulan" element={<ProtectedRoute><MPindahBulan /></ProtectedRoute>} />
            <Route path="/group-account" element={<ProtectedRoute><MGroupAccount /></ProtectedRoute>} />
            <Route path="/master-chart-account" element={<ProtectedRoute><MMasterChartAccount /></ProtectedRoute>} />
            <Route path="/chart-of-account-master" element={<ProtectedRoute><MChartOfAccount /></ProtectedRoute>} />


            {/* <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/user" element={<User />} /> */}
          </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
